import PropTypes from "prop-types";
import React, { useState, useRef, useEffect } from "react";
import { getPhoenixFormVersion } from "requests/homeowner/caseforms";
import MSpinner from "components/Shared/MSpinner.tsx";
import Appraisal1004p70hV4 from "components/Homeowner/CaseForms/Appraisal1004P70H/V4/Appraisal1004pV4";
import Appraisal1004p70hV5 from "components/Homeowner/CaseForms/Appraisal1004P70H/V5/Appraisal1004pV5";

export const Appraisal1004p70h = props => {
  const mounted = useRef(true);

  const [version, setVersion] = useState(0);
  const [isFetchingVersion, setIsFetchingVersion] = useState(true);

  useEffect(() => {
    getPhoenixFormVersion(props.controlNumber, (payload) => {
      setVersion(payload);
      setIsFetchingVersion(false);
    }, mounted);
    return (() => { mounted.current = false; });
  }, []);

  if (isFetchingVersion) return <MSpinner />;

  let versionedComponents = [];
  // The 0 and 1 are here just in case someone switches a case from the 1004P form to the 1004 Hybrid/70H form
  versionedComponents[0] = Appraisal1004p70hV4;
  versionedComponents[1] = Appraisal1004p70hV4;
  versionedComponents[4] = Appraisal1004p70hV4;
  versionedComponents["0"] = Appraisal1004p70hV4;
  versionedComponents["1"] = Appraisal1004p70hV4;
  versionedComponents["4"] = Appraisal1004p70hV4;
  versionedComponents["5"] = Appraisal1004p70hV5;
  versionedComponents["PhoenixFormVersionNoneFound"] = Appraisal1004p70hV4;
  let MyComponent = versionedComponents[version];
  if (!MyComponent) {
    throw new Error(`No corresponding 1004 Hybrid/70H frontend version for backend version: ${version}`);
  }
  return (<MyComponent
    controlNumber={props.controlNumber}
    onChange={props.onChange}
    onSave={props.onSave}
    readOnly={props.readOnly}
  />);
};

Appraisal1004p70h.propTypes = {
  controlNumber: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  onSave: PropTypes.func,
  readOnly: PropTypes.bool,
};

export default Appraisal1004p70h;
